<div class="filterContainer">
  <button class="home365-button inverted board-button" >
    <div class="mainFilterButton" [matMenuTriggerFor]="filterMenu">
      {{'FILTER.BUTTON_TITLE' | translate}}
      <span *ngIf="filtersList.length > 0">: {{filtersList.length}}</span>
      <i *ngIf="filtersList.length === 0" class="fa-regular fa-chevron-down mainFilterIcon"></i>
    </div>
    <i *ngIf="filtersList.length > 0" class="fa-regular fa-xmark mainFilterIcon" (click)="restFilters()"></i>
  </button>

  <div class="filterTagsContainer">
    <div class="tag" *ngFor="let tag of filtersList | slice:0: maxFilterDisplayed">
      <div class="tagBody" [ngSwitch]="tag.type">
        <div
          *ngSwitchCase="'ticket_status'"
          matTooltip="{{getTooltipValues('ticket_status')}}"
          matTooltipClass="home365-filter-mat-tooltip"
          matTooltipPosition="below"
        >
          <span *ngIf="tag.value === 1">
            <ng-container *ngTemplateOutlet="ticketStatusTag; context: {value: ticket_status.value[0]}"></ng-container>
          </span>
          <span *ngIf="tag.value > 1">
            {{ 'FILTER.TICKET_STATUS' | translate}}: {{ticket_status.value?.length}}
          </span>
        </div>
        <div *ngSwitchCase="'messages'">
          <ng-container *ngTemplateOutlet="messagesTag"></ng-container>
        </div>
        <div
            *ngSwitchCase="'categories'"
            matTooltip="{{getTooltipValues('categories')}}"
            matTooltipClass="home365-filter-mat-tooltip"
            matTooltipPosition="below"
            >
            <span *ngIf="tag.value === 1">
              {{categories.value[0]}}
            </span>
            <span *ngIf="tag.value > 1">
              {{ 'FILTER.CATEGORY' | translate}}: {{categories.value?.length}}
            </span>

        </div>
      </div>
      <i class="fa-light fa-xmark claerTag" (click)="clearTag(tag)"></i>
    </div>
    <div class="tag" *ngIf="filtersList.length > maxFilterDisplayed">
      + {{filtersList.length - maxFilterDisplayed}} {{ 'GENERAL_TEXTS.AG_GRID.MORE_TEXT' | translate}}
    </div>
  </div>
</div>

<mat-menu #filterMenu="matMenu">

  <button mat-menu-item class="filterMenuButton" [matMenuTriggerFor]="messagesMenu">
    <div class="filterMenuTitle">
      {{ 'FILTER.MESSAGES' | translate}}  <span class="filterMenuTitleSelection" *ngIf="messages.value">:  <ng-container *ngTemplateOutlet="messagesTag"></ng-container></span>
    </div>
    <i class="fa-regular fa-chevron-down arrow"></i>
  </button>

  <button mat-menu-item class="filterMenuButton" [matMenuTriggerFor]="statusMenu">
    <div class="filterMenuTitle">
      {{ 'FILTER.TICKET_STATUS' | translate}}
      <span class="filterMenuTitleSelection" *ngIf="ticket_status.value?.length === 1">: <ng-container *ngTemplateOutlet="ticketStatusTag; context: {value: ticket_status.value[0]}"></ng-container></span>
      <span class="filterMenuTitleSelection" *ngIf="ticket_status.value?.length > 1">: {{ticket_status.value?.length}} {{ 'FILTER.SELECTED' | translate}}</span>
    </div>
    <i class="fa-regular fa-chevron-down arrow"></i>
  </button>

  <button mat-menu-item class="filterMenuButton" [matMenuTriggerFor]="categoryMenu">
    <div class="filterMenuTitle">
      {{ 'FILTER.CATEGORY' | translate}}
      <span class="filterMenuTitleSelection" *ngIf="categories.value?.length === 1">: {{categories.value[0]}}</span>
      <span class="filterMenuTitleSelection" *ngIf="categories.value?.length > 1">: {{categories.value?.length}} {{ 'FILTER.SELECTED' | translate}}</span>
    </div>
    <i class="fa-regular fa-chevron-down arrow"></i>
  </button>

  <div class="buttonsContainer">
    <button class="home365-button inverted board-button clear-all-buttton" (click)="restFilters()" [ngClass]="{'disabled': filtersList.length === 0}">
      {{'FILTER.CLEAR_ALL_BUTTON' | translate}}
    </button>
    <button class="home365-button board-button clear-all-buttton" (click)="applayFilter()">
      {{'FILTER.APPLY_BUTTON' | translate}}
    </button>
  </div>

</mat-menu>

<mat-menu #messagesMenu="matMenu">
  <!-- <button mat-menu-item class="filterSubMenuButton" [ngClass]="{'selected': plan.value === 'all'}" (click)="setValue('plan','all')"> {{ 'FILTER.ALL' | translate}}</button> -->
  <button mat-menu-item class="filterSubMenuButton" [ngClass]="{'selected': messages.value === 'unread'}" (click)="setValue('messages','unread');$event.stopPropagation()"> {{ 'FILTER.UNREAD' | translate}}</button>
  <button mat-menu-item class="filterSubMenuButton" [ngClass]="{'selected': messages.value === 'read'}" (click)="setValue('messages', 'read');$event.stopPropagation()"> {{ 'FILTER.READ' | translate}}</button>
</mat-menu>

<mat-menu #categoryMenu="matMenu">
  <ng-container *ngFor="let item of categoriesList$ | async">
    <button *ngIf="!item.hideFromCustomerFilter" mat-menu-item class="filterSubMenuButton"
            [ngClass]="{'selected': categories.value?.includes(item.label)}"
            (click)="setValue('categories',item.label);$event.stopPropagation()">
      <mat-checkbox class="example-margin" [checked]="categories.value?.includes(item.label)"
                    (click)="disableCheckbox($event)"></mat-checkbox>
      <div class="statusButtonContainer">
        {{ item.label }}
      </div>
    </button>
  </ng-container>
</mat-menu>

<mat-menu #statusMenu="matMenu">
  <button mat-menu-item class="filterSubMenuButton" [ngClass]="{'selected': ticket_status.value?.includes(eTicketStatus.open)}" (click)="setValue('ticket_status',eTicketStatus.open);$event.stopPropagation()">
    <mat-checkbox class="example-margin" [checked]="ticket_status.value?.includes(eTicketStatus.open)"  (click)="disableCheckbox($event)"></mat-checkbox>
    <div class="statusButtonContainer open">
      {{ 'TICKET_STATUS.OPEN' | translate}}
    </div>
  </button>
  <button mat-menu-item class="filterSubMenuButton" [ngClass]="{'selected': ticket_status.value?.includes(eTicketStatus.in_progress)}" (click)="setValue('ticket_status',eTicketStatus.in_progress);$event.stopPropagation()">
    <mat-checkbox class="example-margin" [checked]="ticket_status.value?.includes(eTicketStatus.in_progress)"  (click)="disableCheckbox($event)"></mat-checkbox>
    <div class="statusButtonContainer inProgress">
      {{ 'TICKET_STATUS.IN_PROGRESS' | translate}}
    </div>
  </button>
  <button mat-menu-item class="filterSubMenuButton" [ngClass]="{'selected': ticket_status.value?.includes(eTicketStatus.completed)}" (click)="setValue('ticket_status',eTicketStatus.completed);$event.stopPropagation()">
    <mat-checkbox class="example-margin" [checked]="ticket_status.value?.includes(eTicketStatus.completed)"  (click)="disableCheckbox($event)"></mat-checkbox>
    <div class="statusButtonContainer completed">
      {{ 'TICKET_STATUS.COMPLETED' | translate}}
    </div>
  </button>
  <!-- <button  mat-menu-item class="filterSubMenuButton" [ngClass]="{'selected': ticket_status.value?.includes(eTicketStatus.closed)}" (click)="setValue('ticket_status',eTicketStatus.closed)">
    <div class="statusButtonContainer closed">
      {{ 'TICKET_STATUS.CLOSED' | translate}}
    </div>
  </button> -->
  <!-- <button  mat-menu-item class="filterSubMenuButton" [ngClass]="{'selected': ticket_status.value === eTicketStatus.canceled}" (click)="setValue('ticket_status',eTicketStatus.canceled)">
    <div class="statusButtonContainer canceled">
      {{ 'TICKET_STATUS.CANCELED' | translate}}
    </div>
  </button> -->
  <!-- <button mat-menu-item class="filterSubMenuButton" *ngIf="type != 'messages'" [ngClass]="{'selected': ticket_status.value === eTicketStatus.blocked}" (click)="setValue('ticket_status',eTicketStatus.blocked)">
    <div class="statusButtonContainer blocked">
      {{ 'TICKET_STATUS.BLOCKED' | translate}}
    </div>
  </button> -->

  <!-- <button mat-menu-item class="filterSubMenuButton" [ngClass]="{'selected': ticket_status.value === 'all'}" (click)="setValue('ticket_status','all')"> {{ 'FILTER.ALL' | translate}}</button> -->
</mat-menu>


<ng-template #ticketStatusTag let-value="value">
  <div [ngSwitch]="value">
    <div *ngSwitchCase="eTicketStatus.open" class="statusButtonContainer open">
      {{ 'TICKET_STATUS.OPEN' | translate }}
    </div>
    <div *ngSwitchCase="eTicketStatus.in_progress" class="statusButtonContainer inProgress">
      {{ 'TICKET_STATUS.IN_PROGRESS' | translate }}
    </div>
    <div *ngSwitchCase="eTicketStatus.completed" class="statusButtonContainer completed">
      {{ 'TICKET_STATUS.COMPLETED' | translate }}
    </div>
    <div *ngSwitchCase="eTicketStatus.skipped" class="statusButtonContainer skipped" >
      {{ 'TICKET_STATUS.SKIPPED' | translate }}
    </div>
    <div *ngSwitchCase="eTicketStatus.blocked" class="statusButtonContainer blocked" >
      {{ 'TICKET_STATUS.BLOCKED' | translate }}
    </div>
    <div *ngSwitchCase="eTicketStatus.canceled" class="statusButtonContainer canceled" >
      {{ 'TICKET_STATUS.CANCELED' | translate }}
    </div>
  </div>
</ng-template>

<ng-template #messagesTag>
  <div [ngSwitch]="messages.value">
    <div *ngSwitchCase="'read'" class="">
      {{ 'FILTER.READ' | translate }}
    </div>
    <div *ngSwitchCase="'unread'" class="">
      {{ 'FILTER.UNREAD' | translate }}
    </div>
  </div>
</ng-template>


